import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { menuData } from '../menuData'; // Import the dish data
import './MenuPage.css';

// --- Menu Generation Logic ---
// Shuffles an array to ensure randomness
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

// Generates a menu for a given number of weeks
function generateRotationalMenu(weeks) {
  const weeklyScheme = {
    Monday: 'chicken',
    Tuesday: 'lentils',
    Wednesday: 'beef',
    Thursday: 'vegetable',
    Friday: 'rice',
  };

  // Create shuffled copies of the dish lists to pick from
  const availableDishes = {
    chicken: shuffleArray([...menuData.chicken]),
    lentils: shuffleArray([...menuData.lentils]),
    vegetable: shuffleArray([...menuData.vegetable]),
    rice: shuffleArray([...menuData.rice]),
    beef: shuffleArray([...menuData.beef]),
  };

  const fullMenu = [];

  for (let i = 0; i < weeks; i++) {
    const weeklyMenu = {};
    for (const day in weeklyScheme) {
      const category = weeklyScheme[day];
      // Pick the next available dish from the shuffled list
      // The modulo operator (%) makes it loop back to the start if we run out of dishes
      weeklyMenu[day] = availableDishes[category][i % availableDishes[category].length];
    }
    fullMenu.push({ week: i + 1, days: weeklyMenu });
  }

  return fullMenu;
}
// --- End of Logic ---


function MenuPage() {
  // Generate a 4-week (monthly) menu
  const monthlyMenu = generateRotationalMenu(4);

  return (
    <div className="menu-page-container">
      <Header />
      <main className="menu-main">
        <div className="menu-header">
          <h1>Monthly Rotational Menu</h1>
          <p>Our menu is carefully curated each week to provide variety and authentic homemade taste. Here is the plan for the upcoming month.</p>
        </div>

        <div className="menu-layout">
          {monthlyMenu.map(weekData => (
            <div key={weekData.week} className="week-container">
              <h2>Week {weekData.week}</h2>
              <div className="day-grid">
                {Object.entries(weekData.days).map(([day, dish]) => (
                  <div key={day} className="day-card">
                    <h3>{day}</h3>
                    <h4>{dish.name}</h4>
                    <p>{dish.description}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default MenuPage;
